import * as _ from 'lodash';
import { useEffect, useState } from 'react';
import { connect, Dispatch } from 'react-redux';
import { IBaseResponse, IContact, IContactRequest, IListItem, IPhoneNumberRequest } from '@nkr/models/index'
import { ContactEntityType } from '@nkr/enums/index';
import { AppActionCreators, ContactActionCreators, IApplicationState, IContactFullListResponse, IContactResponse } from '@nkr/store/index';
import { Button, Modal } from 'react-bootstrap'
import { ContactsTableWrapper } from '../styles';
import { Utility } from '@nkr/services/utility';
import { toast } from 'react-toastify';
import { IContactForEdit } from './contact-for-edit';
import { initialValidation, IValidation } from './validation';
import usePrevious from '@nkr/services/use-previous';
import ConfirmDeleteContact from './confirm-delete-contact';
import ContactRow from './contact-row';
import OpoContactAddEdit from './add-edit';

interface IProps {
    show: boolean,
    opoId: number,
    opoNkrName: string,
    positionList: IListItem[],
    phoneTypes: IListItem[],
    onClose: (contactCount: number) => void
}

interface IStateProps {
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getContacts: (entityTypeId: number) => Promise<IContactFullListResponse>,
    saveContact: (request: IContactRequest) => Promise<IContactResponse>,
    deleteContact: (id: number) => Promise<IBaseResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

const OpoContacts = (props: TProps) => {
    const [list, setList] = useState<IContact[]>([]);
    const [editContact, setEditContact] = useState<IContactForEdit>(null);
    const [deleteContact, setDeleteContact] = useState<IContactForEdit>(null);
    const [validation, setValidation] = useState<IValidation>({ ...initialValidation });

    const previousShow = usePrevious(props.show);

    useEffect(() => {
        if (previousShow == false && props.show == true) {
            setEditContact(null);
            setDeleteContact(null);

            getContacts();
        }
    }, [props.show]);

    const getContacts = () => {
        props.showLoading('Getting OPO contacts, one moment please...').then(() => {
            props.getContacts(props.opoId)
                .then(response => {
                    if (response.data.success) {
                        setList(response.data.results);
                    }
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    props.hideLoading();
                });
        });
    };

    const validate = () => {
        let updatedValidation: IValidation = { ...initialValidation };

        updatedValidation.firstName = editContact.firstName != '';
        updatedValidation.lastName = editContact.lastName != '';
        updatedValidation.email = Utility.isValidEmail(editContact.email);

        let isValid = updatedValidation.firstName && updatedValidation.lastName && updatedValidation.email;

        return { updatedValidation, isValid };
    }

    const handleAdd = () => {
        let newEdit: IContactForEdit = {
            currentPositions: [],
            id: 0,
            isDeleted: false,
            entityType: 0,
            entityTypeName: '',
            entityTypeId: 0,
            centerName: '',
            positionText: '',
            nameHonorific: '',
            fullName: '',
            nameSuffix: '',
            email: '',
            secondaryEmail: '',
            addressId1: 0,
            address1Suite: '',
            address1Override: undefined,
            addressId2: 0,
            address2Suite: '',
            address2Override: '',
            galaEmailOverride: '',
            conferenceNumber: '',
            conferenceNumberCode: '',
            conferenceNumberMobileFriendly: '',
            currentCaseLoad: 0,
            maxCaseLoad: 0,
            address1: undefined,
            address2: undefined,
            organType: null,
            positions: [],
            emailFlags: [],
            phoneNumbers: [],
            phoneNumbersForEdit: [],
            tags: [],
            center: undefined,
            isRccapManager: false, isLiaison: false, isSwapManager: false, isFinancialController: false,
            isCfo: false, isOperations: false, isMicrositeManager: false, IsMemberServices: false,
            IsDutyOfficer: false, IsLegalCounsel: false, IsDirectorOperations: false,
            titles: [],
            backgroundColor: '', color: '',
            firstName: '', middleName: '', lastName: '',
            abbreviation: ''
        };

        setEditContact(newEdit)
    };

    const handleEdit = (id: number) => {
        let f = list.find(x => x.id == id);
        let newEdit: IContactForEdit = { ...f, currentPositions: f.positions.map(x => x.id), phoneNumbersForEdit: f.phoneNumbers.map(x => ({ ...x, edit: false })) };

        setEditContact(newEdit);
    };

    const handleConfirmDelete = (id: number) => {
        let f = list.find(x => x.id == id);
        let newDelete: IContactForEdit = { ...f, currentPositions: f.positions.map(x => x.id), phoneNumbersForEdit: f.phoneNumbers.map(x => ({ ...x, edit: false })) };

        setDeleteContact(newDelete);
    };

    const handleClose = () => {
        props.onClose(list.length);
    };

    const handleAddEditDataChange = (data: IContactForEdit) => {
        setEditContact(data);
    };

    const handleCancelAddEdit = () => {
        setEditContact(null);
    };

    const handleSaveContact = () => {
        let { updatedValidation, isValid } = validate();

        setValidation(updatedValidation)

        if (isValid) {
            let {
                id, nameHonorific: prefix, firstName, middleName, lastName, nameSuffix: suffix,
                email, positionText: title,
                currentPositions,
                phoneNumbersForEdit
            } = editContact;

            let request: IContactRequest = {
                id,
                isDeleted: false,
                entityType: ContactEntityType.Opo,
                entityTypeId: props.opoId,
                positions: currentPositions,
                title,
                prefix,
                firstName,
                middleName,
                lastName,
                nameSuffix: suffix,
                email,
                secondaryEmail: '',
                addressId1: 0,
                address1Suite: '',
                address1Override: undefined,
                addressId2: 0,
                address2Suite: '',
                address2Override: '',
                galaEmailOverride: '',
                conferenceNumber: '',
                conferenceNumberCode: '',
                conferenceNumberMobileFriendly: '',
                organType: null,
                phoneNumbers: phoneNumbersForEdit.map(x => {
                    let ph: IPhoneNumberRequest = {
                        id: x.id > 0 ? x.id : 0,
                        isDeleted: x.isDeleted,
                        phoneTypeId: x.phoneTypeId,
                        number: x.number,
                        mobileProviderId: 0,
                        contactId: id
                    };

                    return ph;
                }),
                emailFlags: [],
                tags: []
            };

            props.showLoading('Saving OPO contact, one moment please...').then(() => {
                props.saveContact(request)
                    .then(response => {
                        if (response.data.success) {
                            let updatedList = _.cloneDeep(list)

                            if (id == 0) {
                                updatedList.push(response.data.results.contact);
                            } else {
                                updatedList = updatedList.map(c => {
                                    if (c.id == id) {
                                        return response.data.results.contact;
                                    }

                                    return c;
                                });
                            }

                            setEditContact(null);
                            setList(updatedList);
                            toast.success('OPO contact saved successfully');
                        }
                    })
                    .catch(error => {
                        toast.error('Unable to save OPO contact: ' + error)
                    })
                    .finally(() => {
                        props.hideLoading();
                    });
            });
        }
    };

    const handleDelete = () => {
        props.showLoading('Deleting OPO contact, one moment please...').then(() => {
            props.deleteContact(deleteContact.id)
                .then(response => {
                    if (response.data.success) {
                        let updatedList = _.cloneDeep(list).filter(x => x.id != deleteContact.id);

                        setDeleteContact(null);
                        setList(updatedList);
                        toast.success('OPO contact succcessfully deleted');
                    }
                })
                .catch(error => {
                    toast.error('Unable to save OPO contact: ' + error)
                })
                .finally(() => {
                    props.hideLoading();
                });
        });
    };

    return (
        <Modal backdrop='static' bsSize='lg' show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>OPO Contact Management for <strong>{props.opoNkrName}</strong></Modal.Header>
            <Modal.Body>
                <ContactsTableWrapper condensed striped bordered>
                    <thead>
                        <tr>
                            <th>Role(s)</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th><Button bsStyle='primary' bsSize='sm' onClick={handleAdd}>Add Contact</Button></th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map(item =>
                            <ContactRow
                                data={item}
                                edit={editContact != null && editContact.id == item.id}
                                delete={deleteContact != null && deleteContact.id == item.id}
                                onEdit={handleEdit}
                                onConfirmDelete={handleConfirmDelete} />
                        )}
                    </tbody>
                </ContactsTableWrapper>

                {editContact != null && (
                    <OpoContactAddEdit
                        data={editContact}
                        validation={validation}
                        phoneTypes={props.phoneTypes}
                        positionList={props.positionList}
                        onAddEditChange={handleAddEditDataChange}
                        onSave={handleSaveContact}
                        onCancel={handleCancelAddEdit}
                    />
                )}

                {deleteContact != null && (
                    <ConfirmDeleteContact
                        data={deleteContact}
                        onYes={handleDelete}
                        onNo={() => setDeleteContact(null)} />
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}


const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getContacts: (entityTypeId: number) => {
            return dispatch(ContactActionCreators.getFullList(1, entityTypeId));
        },
        saveContact: (request) => {
            return dispatch(ContactActionCreators.saveContact(request));
        },
        deleteContact: (id) => {
            return dispatch(ContactActionCreators.deleteContact(id));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(OpoContacts);

